import { useState, useEffect } from 'react';
import { Paper, Text, Button, Group, Box } from '@mantine/core';
import { IconCookie } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'sata_cookie_consent';

/**
 * Cookie/lokal saqlash haqida xabar beruvchi banner.
 * Faqat ZARURIY saqlash ishlatiladi (kirish tokeni, til, mavzu) — shuning uchun
 * "rad etish" varianti yo'q: usiz tizimga kirib bo'lmaydi. Banner xabardor qiladi.
 *
 * DIQQAT: bu FIXED, lekin CHEGARALANGAN element (butun ekranni qoplamaydi) —
 * ko'rinmas overlay hosil qilib mouse hodisalarini yutmaydi.
 */
export function CookieConsent() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      setShow(localStorage.getItem(CONSENT_KEY) !== 'accepted');
    } catch {
      // localStorage o'chirilgan bo'lsa — bannerni ko'rsatmaymiz
      setShow(false);
    }
  }, []);

  if (!show) return null;

  const accept = () => {
    try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch { /* ignore */ }
    setShow(false);
  };

  return (
    <Paper
      withBorder
      shadow="md"
      radius="md"
      p="md"
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 16,
        maxWidth: 720,
        margin: '0 auto',
        zIndex: 300,
      }}
    >
      {/* Telefonda tugmalar matn OSTIGA tushadi — yonma-yon turganda matn
          bir so'zdan iborat tor ustunga siqilib, oyna ekranning yarmini egallardi. */}
      <Group wrap="wrap" align="flex-start" gap="sm">
        <Box pt={2}><IconCookie size={22} /></Box>
        <Box style={{ flex: 1, minWidth: 200 }}>
          <Text size="sm" fw={600} mb={2}>{t('legal.cookieTitle')}</Text>
          <Text size="xs" c="dimmed">{t('legal.cookieText')}</Text>
        </Box>
        <Group gap="xs" wrap="nowrap" ml="auto">
          <Button component={Link} to="/cookies" size="xs" variant="default">
            {t('legal.more')}
          </Button>
          <Button size="xs" onClick={accept}>{t('legal.accept')}</Button>
        </Group>
      </Group>
    </Paper>
  );
}
